/**
 * Current user resource
 * This resource will load current user data from local storage into the Redux store.
 *
 * NOTE: Resources must default export a function that returns a Promise resolved with an object where the key is the
 * RESOURCE_KEY and the value is loaded resource data. Resources can be used to get any resource but are most useful for
 * loading global app resources needed by the app to work properly.
 */
import auth from "Auth/index";
import {setStorageValue, STORAGE_TYPE} from "../storage";
import {current_user_name_storage_field_name, current_user_storage_field_name} from 'Config/auth';
import {acl_storage_var} from 'Config/acl';
import ACL from 'Acl/index';

export const RESOURCE_KEY = 'currentUser';

/**
 * Resource function
 * @return {Promise<Object<string, any>>} Promise that will resolve with an object where key is the RESOURCE_KEY and
 * value is loaded resource data.
 */
function resourceFunction() {
	const currentUserName = auth.getCurrentUserName();
	const currentUser = auth.getCurrentUser();
	const currentUserAcl = ACL.get();
	
	setStorageValue(current_user_name_storage_field_name, currentUserName, STORAGE_TYPE.REDUX);
	setStorageValue(acl_storage_var, currentUserAcl, STORAGE_TYPE.REDUX);
	
	if (setStorageValue(current_user_storage_field_name, currentUser, STORAGE_TYPE.REDUX)) {
		return Promise.resolve({[RESOURCE_KEY]: currentUser});
	} else {
		return Promise.resolve({[RESOURCE_KEY]: null});
	}
}

export default resourceFunction;